import React from 'react';

import './CustomToggleButton.scss';
import {ToggleButton} from "primereact/togglebutton";
import {T} from 'services/lang/LanguageService';

type TimeDropdownProps = {
    active: boolean,
    setActive(newValue: boolean): void
}

const CustomToggleButton = ({active, setActive}: TimeDropdownProps) => {
    return <div className="custom-toggle-button">
            <ToggleButton className="p-button-sm"
                          onIcon="pi pi-power-off"
                          offIcon="pi pi-power-off"
                          onLabel=""
                          offLabel=""
                          checked={active}
                          onChange={(e) => {
                                  setActive(e.value)
                          }}
                          tooltip={active? T("message.auto-refresh-turned-on"): T("message.auto-refresh-turned-off")}
                          tooltipOptions={{position: "bottom"}}
            />
    </div>
};

export default CustomToggleButton;